import { LabelValueInterface } from "../models/common.models";
import { DEFAULT_CURRENCIES } from "./constants";


export const getCurrencyByIso = (iso: string = 'brl'): LabelValueInterface | undefined => {
    return DEFAULT_CURRENCIES.find((currency) => currency.value.toLowerCase() === iso.toLowerCase());
};

export const getCurrencySymbol = (iso: string = 'brl'): string => {
    const currency = getCurrencyByIso(iso);
    return currency ? currency.label : '';
};

export const formatCurrency = (value: number, iso: string = 'brl', language: string = 'pt-BR'): string => {
    return value.toLocaleString(language, {
        style: 'currency',
        currency: iso,
    });
};

export const formatCurrencyNoDecimal = (value: number, iso: string = 'brl', language: string = 'pt-BR'): string => {
    return value.toLocaleString(language, {
        style: 'currency',
        currency: iso,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
}
